import { useCallback, useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import { switcherDataAutomation } from "app/pages/activation/components/GranularitySwitcher/dataAutomationKeys";
import { headerGranularitySwitcherTexts } from "app/pages/activation/components/GranularitySwitcher/texts";
import { activationTracking } from "app/pages/activation/services/tracking";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

import { GRANULARITY_LIST } from "../Header/constants";
import GranularitySwitch from "../Shared/GranularitySwitch/GranularitySwitch";

import * as SC from "./styles";

type GranularitySchema = { timeGranularity: GranularityNames };

export const GranularitySwitcher = ({ timeGranularity }: GranularitySchema) => {
    const granularityIndex = useMemo(
        () => Object.keys(GRANULARITY_LIST).findIndex((granularity) => granularity === timeGranularity),
        [timeGranularity],
    );

    const onClick = useCallback((granId: number) => {
        const granularityApi = Object.keys(GRANULARITY_LIST)[granId];

        proNavigator.updateParams({
            timeGranularity: granularityApi,
        });

        activationTracking.home.trackGranularityToggle(granularityApi);
    }, []);

    return (
        <SC.Container data-automation={switcherDataAutomation.container}>
            <SC.Title data-automation={switcherDataAutomation.title}>
                {translate(headerGranularitySwitcherTexts.title)}:
            </SC.Title>

            <GranularitySwitch
                granularities={GRANULARITY_LIST}
                onClick={onClick}
                selectedIndex={granularityIndex}
                dataAutomation={switcherDataAutomation.switcher}
            />
        </SC.Container>
    );
};

GranularitySwitcher.displayName = "GranularitySwitcher";
